import { useQuery } from '@tanstack/react-query';
import { getEVSE } from '../../api/evse.ts';

export default function useEVSE(evseId: string) {
  return useQuery({
    queryKey: ['evses', evseId],
    queryFn: async () => {
      return await getEVSE(evseId);
    },
    enabled: !!evseId,
  });
}
